import { Project } from '../components/ProjectList';

export const migrateProjects = (projects: any[]): Project[] => {
  if (!Array.isArray(projects)) return projects;
  return projects.map(project => ({
    ...project,
    matrixType: project.matrixType || 'RAPID' // Default to RAPID for existing projects
  }));
};

export const migrateAllProjects = (data: any): any => {
  // This is for the project data structure, not the projects list
  return data;
};

export const backupData = (key: string, data: any): void => {
  try {
    const backupKey = `${key}_backup_${Date.now()}`;
    window.localStorage.setItem(backupKey, JSON.stringify(data));
    // Keep only the last 3 backups
    const backups = Object.keys(window.localStorage)
      .filter(k => k.startsWith(`${key}_backup_`))
      .sort()
      .reverse();
    if (backups.length > 3) {
      backups.slice(3).forEach(backup => window.localStorage.removeItem(backup));
    }
  } catch (error) {
    console.error('Failed to create backup:', error);
  }
};